import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    marginBottom: 40,
    flexWrap: 'nowrap'
  },
  container: {
    position: 'relative',
    padding: 0
  },
  fixedButtonContainer: {
    position: 'fixed',
    top: theme.sizes.headerHeight + 40,
    left: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  iconButtonRoot: {
    position: 'absolute',
    color: theme.colors.button__background_secondary,
    left: -48,
    padding: 0
  },
  iconButtonLabel: {
    height: 48,
    width: 48
  },
  icon: {
    height: 48,
    width: 48
  },
  iconImg: {
    transform: 'rotate(180deg)'
  },
  navigatorIconImg: {
    height: 40,
    width: 40
  },
  rightLabel: {
    fontSize: '14px',
    display: 'inline',
    marginRight: 8
  },
  rightValue: {
    fontSize: '14px',
    display: 'inline'
  },
  rightContainer: {
    composes: '$container',
    marginTop: 10
  },
  subtitle: {
    paddingRight: 10
  },
  rightSideInfo: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: 8
  },
  sourceLabel: {
    fontSize: '14px',
    display: 'inline',
    marginRight: 0
  },
  sourceTooltipIcon: {
    width: 16,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(2)
  },
  agencyTag: {
    backgroundColor: theme.colorPalette.beige_60,
    padding: theme.spacing(2, 4),
    height: 32,
    width: 136,
    gap: theme.spacing(2)
  },
  statusPillBase: {
    borderRadius: theme.spacing(8),
    fontSize: 12,
    fontWeight: 600,
    height: 24,
    padding: theme.spacing(1, 2),
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    marginLeft: theme.spacing(2)
  },
  statusPillActive: { backgroundColor: theme.colorPalette.green_50, color: theme.colorPalette.green_100 },
  statusPillFuture: { backgroundColor: theme.colorPalette.green_75, color: theme.colorPalette.white },
  statusPillInCancellation: { backgroundColor: theme.colorPalette.orange_50, color: theme.colorPalette.white },
  statusPillCancelled: { backgroundColor: theme.colorPalette.beige_75, color: theme.colorPalette.white },
  statusPillInactive: { backgroundColor: theme.colorPalette.beige_60, color: theme.colorPalette.green_100 }
});

export default makeStyles(styles);
